module.exports = __webpack_public_path__ + "static/media/specialty-other.a294febc.svg";